<template>
  <div>
    <h3>Apply to access the Trove API</h3>
	
    <div class="apply">
      <p>To apply for a Trove API key, please <a href="https://librariesaustraliaref.nla.gov.au/reft100.aspx?key=TroveAPIKey" target="_new">submit an application form</a>. We will typically respond within 3 business days.</p>
      <p>
      	If you would like to learn more about the Trove API, check out our <a href="https://trove.nla.gov.au/about/create-something/using-the-api/what-is-the-trove-api" target="_new">'What is the Trove API?'</a> information page.
      </p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.error {
  color: colour(form-field-error);
}

.hint {
  font-size: small;
}

.apply {
  margin-top: 1rem;
}
</style>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import service from '@/service/service'
import profile from '@/mixins/profile'
import scroll from 'vue-scrollto'

const FORM_DEFAULT = {
  accept: 'n',
  agreement: null,
  usage: null,
  organisation: null,
  name: null,
  email: null,
  phone: null,
}

export default {
  name: 'APIApply',
  mixins: [profile],
}
</script>
